import React from "react"

import { AppAntSwitch } from "@components"
import { showFeatures } from "@signals"


export default function AppCommonFiltersShowFeatures({ ...props }) {
	return <AppAntSwitch
		trueText="Vehicle features"
		checked={showFeatures.value}
		onChange={newValue => showFeatures.value = newValue.target.checked}
		{...props}
	/>
}